<template>
  <div>
    <el-container direction="vertical" class="layout-container">
      <HEAD :active="active"></HEAD>
      <el-main class="el-main-ms">
        <!--图片层-->
        <main-plugin :img-src="imgSrc"></main-plugin>
        <div style="text-align: left;text-align: left;width: 85%;display: inline-block;">
          <h5 class="ab-title"><span style="border-bottom: 1px solid rgb(124, 185, 186);">企业简介：</span></h5>
          <p>陌上酒店集团，“1+X+1”的酒店产业新模式， [1]  旗下拥有多个文化IP系列，其中“东方文化”系列有四大品牌：“陌上轻奢”、 “陌上轻雅”、“陌上轻居”、 “陌上轻宿”，分别以“茶、花、酒、诗”为文化主题。</p>
          <el-divider></el-divider>
          <h5 class="ab-title"><span style="border-bottom: 1px solid rgb(124, 185, 186);">企业故事：</span></h5>
          <p>陌上，名字来源于宋代杭州的吴越王钱镠写给爱妻的一封信，“陌上花开，可缓缓归矣”</p>
          <el-divider></el-divider>
          <h5 class="ab-title"><span style="border-bottom: 1px solid rgb(124, 185, 186);">企业文化：</span></h5>
          <p>愿景：成为东方文化酒店世界第一品牌<br/>
            使命：复兴民族文化，传递东方美学<br/>
            价值观：健康 责任 专业 敬业 迭代 互相成就</p>
          <el-divider></el-divider>
        </div>
        <!--联系我们-->
        <contact-plugin></contact-plugin>
      </el-main>
      <FOOT></FOOT>
    </el-container>
  </div>
</template>

<script>
import HEAD from './Head'
import FOOT from './Foot'
import MainPlugin from "@/components/MainPlugin";
import ContactPlugin from "@/components/ContactPlugin";
export default {
  name: "About",
  metaInfo: {
    title: '陌上酒店集团官网', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '关于陌上酒店 联系我们'
    },{
      name: 'description',
      content: '关于陌上酒店'
    }]
  },
  data() {
    return {
      active: '2',
      imgSrc: require('../assets/images/mspp-pgcs.png')
    }
  },
  components: {
    HEAD,
    FOOT,
    MainPlugin,
    ContactPlugin
  }
}
</script>

<style scoped>
  .ab-title {
    font-size: 20px;
    font-weight: 550;
  }
</style>

